import { Component, signal, ChangeDetectionStrategy } from "@angular/core";
import { S25Assert } from "../../../util/s25.assert";
import { ModalHeaderComponent } from "../modal.header.component";
import { S25DatePatternModule } from "../../s25-datepattern/s25.datepattern.module";
import { ModalComponent } from "../modal.component";
import type { FormModel } from "../../../pojo/FormI";
import type { TimeModelI } from "../../../pojo/TimeModelI";
import { OccurrenceProfileUtil } from "../../../util/occurrence.profile.util";
import { OccurrenceValidationUtil } from "../../../util/occurrence.validation.util";
import type { OccurrenceI } from "../../../pojo/OccurrenceI";
import { FloatStore } from "../../s25-dropdown/float.store";

export interface EventFormDatePatternPickerModalData {
    profileCode: string;
    formModel: FormModel;
    timeModel: TimeModelI;
    apiBean: { getProfileCode?: () => string };
}

@Component({
    standalone: true,
    providers: [FloatStore],
    imports: [ModalHeaderComponent, S25DatePatternModule],
    styles: `
        :host {
            display: block;
        }
        s25-ng-date-pattern-picker {
            display: block;
            margin-bottom: 1em;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <s25-modal-header [data]="params()"></s25-modal-header>
        <div class="modal-body">
            @if (params()) {
                <s25-ng-date-pattern-picker
                    [profileCode]="params().profileCode"
                    [timeModel]="params().timeModel"
                    [apiBean]="params().apiBean"
                    [editAdHoc]="false"
                />
            }
        </div>
        <div class="modal-footer">
            <div class="aw-button-group">
                @if (errorMsg()) {
                    <div class="ngRed ngBold">{{ errorMsg() }}</div>
                }
                <button type="button" class="aw-button aw-button--outline" (click)="onCancel()">Cancel</button>
                <button type="button" class="aw-button aw-button--primary" (click)="onSelectPattern()">
                    Select Pattern
                </button>
            </div>
        </div>
    `,
})
export class EventFormDatePatternPickerModal extends ModalComponent<EventFormDatePatternPickerModalData> {
    static readonly size = "lg" as const;
    static readonly title = "Pattern Picker";
    static readonly asDialog = true;

    readonly errorMsg = signal("");

    onCancel() {
        this.params()?.closeModal();
    }

    onSelectPattern() {
        this.errorMsg.set("");
        const data = S25Assert.definedValue(this.params());
        const profileCode = data.apiBean.getProfileCode?.() ?? "";
        const patternMapping = null as unknown as OccurrenceI.Mapping;
        if (OccurrenceProfileUtil.reRunPattern(patternMapping, data.formModel, profileCode, true)) {
            data.closeModal({
                confirmed: true,
                ...this.params(),
            });
        } else {
            this.errorMsg.set(OccurrenceValidationUtil.validationErrorText(data.formModel, "date") ?? "");
        }
    }
}
